module.exports = __webpack_public_path__ + "static/img/作品31.232b243.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品31.png
// module id = SDTw
// module chunks = 1